module.exports = __webpack_public_path__ + "img/gine.be926862.png";